import { render, staticRenderFns } from "./PlanoGeneralTab.vue?vue&type=template&id=531d6a61"
import script from "./PlanoGeneralTab.vue?vue&type=script&lang=js"
export * from "./PlanoGeneralTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports